<script>
import { hightText, debounce } from '@/utils/common.js'

import KeyboardInput from 'comp/common/Keyboard/KeyBoardInput.vue'
import { judgeCloseKeyboard, hideKeyboard } from '@/utils/core'

import Tab from 'comp/common/Tab/index.vue'
import Loading from 'comp/common/Loading/index.vue'
import SearchResComponent from 'comp/content/SearchResComponent/index.vue'
import NoData from 'comp/common/NoData/index.vue'

import { getSearchHistory, getHotWords, getSearchResult } from '@/api/search.js'

export default {
  name: 'Search',
  components: { KeyboardInput, Tab, Loading, SearchResComponent, NoData },
  data() {
    return {
      currentCommunity: localStorage.getItem('currentCommunity'),
      /* keyboard */
      judgeCloseKeyboard,
      keyboardShow: false,
      /* search */
      historyList: [],
      recommendList: [],
      searchVal: '',
      /* drop list */
      dropListIsShow: false,
      hotWordsList: [],
      /* search result */
      pageLoading: false,
      tabOptionList: [
        { label: '综合', value: 0 },
        { label: '图文', value: 1 },
        { label: '视频', value: 2 },
        { label: '文件', value: 3 },
        { label: '人员公示', value: 4 },
        { label: '音频', value: 5 }
      ],
      tabCurrentIndex: 0,
      isSearchResult: false,
      searchResList: [],
      pagerConfig: { currentPage: 1, pageSize: 0, total: 0 }
    }
  },
  watch: {
    searchVal(newVal) {
      if (newVal === '') {
        this.dropListIsShow = false
        this.isSearchResult = false
      }
    },
    isSearchResult(newVal) {
      if (!newVal) this.initPageData()
    },
    keyboardShow: {
      handler(newVal) {
        this.$nextTick(() => {
          const parent = document.querySelector('.search-container')
          const distance = newVal ? parent.scrollHeight : 0
          parent.scrollTo({ top: distance, behavior: 'smooth' })
        })
      },
      immediate: true
    }
  },
  created() {
    this.initPageData()
  },
  mounted() {
    hideKeyboard()
  },
  // beforeDestroy() {
  //   Object.assign(this.$data, this.$options.data())
  // },
  methods: {
    hightText,
    onTabClick(v, i) {
      if (this.tabCurrentIndex !== i) {
        this.tabCurrentIndex = i
        this.getSearchResultReq()
      }
    },
    /* request */
    initPageData(state = 1) { // 1-获取 2-删除历史
      getSearchHistory({ village: this.currentCommunity, status: state }).then(res => {
        this.historyList = res?.msg || []
        this.recommendList = res?.msg2 || []
      })
    },
    getHotWords: debounce(function(word) {
      getHotWords({ memo: word }).then(res => {
        this.dropListIsShow = res?.code === 0
        this.hotWordsList = res?.msg || []
      })
    }),
    onHistoryClick({ memo }) {
      this.isSearchResult = true
      this.searchVal = memo
      this.getSearchResultReq()
    },
    getSearchResultReq(memo = this.searchVal) {
      const params = {
        memo,
        title: this.tabOptionList[this.tabCurrentIndex].label,
        pager: this.pagerConfig.currentPage,
        village: this.currentCommunity }
      this.pageLoading = true
      getSearchResult(params).then(res => {
        this.pageLoading = false
        this.pagerConfig.total = res?.count || 0
        this.pagerConfig.pageSize = res?.pagelength || 0
        this.searchResList = res?.msg || []
      }).catch(() => {
        this.pageLoading = false
      })
    },
    onClearHistory() {
      this.$confirm('确认清空搜索历史?', {
        customClass: 'clear-history-confirm',
        confirmButtonClass: 'clear-history-confirm-btn',
        cancelButtonClass: 'clear-history-confirm-cancel-btn'
      }).then(() => {
        getSearchHistory({ village: this.currentCommunity, status: 2 }).then(res => {
          if (res.code === 0) this.initPageData()
        })
      }).catch(() => {})
    },
    toSubpage(v) {
      this.$store.commit('config/SET_DIALOG_COMMON', false)
      // this.$store.dispatch('subpageConfigure/resetComponentConfigure')
      const {
        templateName = '', tid = 0,
        assemblyid = 0, titleid = 0, typeid = 0, title = '', subtitle = '', headname = '',
        id, headline
      } = v
      /* 业务 */
      this.$store.commit('config/SET_CURRENT_TITLE', templateName)
      this.$store.commit('config/SET_CURRENT_TITLE_ID', tid)

      setTimeout(() => {
        /* 组件 */
        const configure = { id: assemblyid, titleid, typeid, title, subtitle: [7, 25].includes(assemblyid) ? headname : subtitle }
        this.$store.commit('subpageConfigure/SET_COMPONENT_CONFIGURE', configure)
        /* 组件数据 */
        const dataConfigure = { id, headline }
        this.$store.commit('subpageConfigure/SET_COMPONENT_DATA_CONFIGURE', dataConfigure)

        this.$store.commit('config/SET_CURRENT_MODALNAME', configure.title)
        this.$store.commit('config/SET_CURRENT_MODULE_ID', configure.id)
        // const whiteList = [15, 61, 66]
        // if (whiteList.includes(configure.id)) return
        this.$store.commit('config/SET_DIALOG', true)
      }, 500)
    },
    /* keyboard */
    inputChange(val) {
      this.searchVal = val.trim()
      if (this.searchVal !== '') this.getHotWords(this.searchVal)
    },
    onInput() {
      // if (this.searchVal) this.dropListIsShow = true
    },
    onFocus() {
      let arr = document.querySelectorAll('.hg-theme-default')
      arr.forEach(ele => {
        this.keyboardShow = ele.style.visibility === 'visible'
      })
    },
    onBlur() {
      setTimeout(() => {
        this.$nextTick(() => {
          let arr = document.querySelectorAll('.hg-theme-default')
          arr.forEach(ele => {
            this.keyboardShow = ele.style.visibility === 'visible'
            // console.log('blur', this.keyboardShow)
          })
        })
      }, 150)
    },
    onKeyPress() {
      let arr = document.querySelectorAll('.hg-theme-default')
      arr.forEach(ele => {
        this.keyboardShow = ele.style.visibility === 'visible'
      })
    },
    onSearchBtnClick() {
      this.dropListIsShow = false
      if (this.searchVal.trim()) {
        this.isSearchResult = true
        this.getSearchResultReq(this.searchVal)
      }
    },
    onContainerClick(e) {
      e.stopPropagation()
      let arr = document.querySelectorAll('.input-keyboard') // 设置目标区域
      let flag = false
      const excludeClassName = [
        'input-keyboard', // 带虚拟键盘的输入框
        'el-input__inner', // 输入框
        'el-input__clear', // 输入框-清除图标
        'el-textarea__inner', // 输入框-textarea
        'hg-candidate-box', // 中文选择框
        'hg-candidate-box-prev', // 中文选择框-上一页
        'hg-candidate-box-list', // 中文选择框-内容列表
        'hg-candidate-box-list-item', // 中文选择框-内容选项
        'hg-candidate-box-next', // 中文选择框-下一页
        'hg-theme-default', // 虚拟键盘
        'hg-rows', // 虚拟键盘-内容
        'hg-row', // 虚拟键盘-行
        'hg-button' // 虚拟键盘-按钮
      ]
      let classList = e.target.classList.value.split(' ')
      let concatArr = excludeClassName.concat(classList)

      arr.forEach(ele => {
        // 判断点击事件发生在区域外的条件是：1. 点击事件的对象不是目标区域本身 2. 事件对象同时也不是目标区域的子元素
        if ( // 判断当前点击的元素类名，是否包含排除元素
          new Set(concatArr).size === concatArr.length &&
          !ele.contains(e.target)
        ) flag = true
      })
      flag && hideKeyboard()
      setTimeout(() => {
        if (flag) this.keyboardShow = false
      }, 160)
    },
    /* pagination */
    onPagerChange(currentPage) {
      this.pagerConfig.currentPage = currentPage
      this.getSearchResultReq()
    },
    /* drop */
    onDropItemClick({ memo }) {
      this.dropListIsShow = false
      this.isSearchResult = true
      this.searchVal = memo
      this.getSearchResultReq(memo)
    }
  }
}
</script>

<template>
  <div @click="onContainerClick">
    <div class="search-container"> <!-- @click="judgeCloseKeyboard" -->
      <div class="top-container">
        <div v-show="!isSearchResult">
          <p class="common-title search-history-title">
            <span>搜索历史</span>
            <span v-if="historyList.length" class="clear-history" @click="onClearHistory"><i class="el-icon-delete" />清空历史</span>
          </p>
          <div v-if="historyList.length" class="history-container">
            <p
              v-for="(v, i) in historyList"
              :key="`history-item-${i}`"
              class="history-item"
              @click="onHistoryClick(v)"
            >{{ v.memo || '' }}</p>
          </div>
          <p v-else class="no-history">暂无搜索历史</p>
        </div>

        <div v-show="!isSearchResult">
          <p class="common-title recommend-title">推荐</p>
          <div class="recommend-container">
            <div v-for="(v, i) in recommendList" :key="`recommend-item-${i}`" class="recommend-item" @click="toSubpage(v)">
              <p class="item-title h-line-1">{{ `${i + 1}. ${v.type === '人员公示' ? v.name : v.headline}` }}</p>
              <p class="item-type">{{ v.type || '' }}</p>
            </div>
          </div>
        </div>

        <div v-if="isSearchResult" class="search-result">
          <Tab :option-list="tabOptionList" :current-index="tabCurrentIndex" @onTabClick="onTabClick" />
          <div class="search-result-list-box">
            <div v-if="!pageLoading && searchResList.length" class="search-result-list-container">
              <SearchResComponent
                v-for="(v, i) in searchResList"
                :key="`search-res-item-${i}`"
                :search-res-item="v"
                :search-val="searchVal"
                @click.native="toSubpage(v)"
              />
            </div>
            <Loading v-if="pageLoading" icon-color="#70B19C" text-color="#70B19C" />
            <NoData v-if="!pageLoading && !searchResList.length" />
          </div>
          <div v-if="!pageLoading && searchResList.length" class="search-res-pagination-box">
            <el-pagination
              background
              :total="pagerConfig.total"
              :page-size="pagerConfig.pageSize"
              :current-page="pagerConfig.currentPage"
              :pager-count="5"
              layout="prev, pager, next"
              @current-change="onPagerChange"
            />
          </div>
        </div>
      </div>

      <div id="form-card" class="form-card">
        <keyboard-input
          class="keyboard-comp"
          keyboard-class="login-username"
          field="username"
          :value="searchVal"
          :maxlength="20"
          prefix-icon="el-icon-search"
          clearable
          placeholder="请输入想搜索的内容"
          @onKeyPress="onKeyPress"
          @inputChange="inputChange"
          @input="onInput"
          @focus="onFocus"
          @blur="onBlur"
        />
        <div class="search-btn-box">
          <button @click.prevent="onSearchBtnClick">搜索</button>
        </div>

        <Transition name="drop-list">
          <div v-show="dropListIsShow" class="drop-list">
            <div
              v-for="(v, i) in hotWordsList"
              :key="`drop-item-${i}`"
              class="drop-list-item"
              @click="onDropItemClick(v)"
            >
              <p class="h-line-1 item-title" v-html="hightText(v.memo, searchVal)" />
              <!-- <p class="item-type">{{ v.type || '' }}</p> -->
            </div>
          </div>
        </Transition>
        <!-- <Transition name="drop-icon">
          <i v-show="dropListIsShow" class="el-icon-error" @click="dropListIsShow = false" />
        </Transition> -->
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.search-container {
  height: 680px;
  overflow-y: scroll;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  &::-webkit-scrollbar { // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
  .top-container {
    height: 410px;
  }
 .common-title {
    font-size: 21px;
    font-weight: bold;
    color: #333;
  }
  .search-history-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .clear-history {
      font-size: 16px;
      color: #999;
      cursor: pointer;
      .el-icon-delete {
        font-size: 18px;
        margin-right: 6px;
      }
      &:hover {
        color: #000;
      }
    }
  }
  .history-container {
    width: 680px;
    height: 100px;
    display: flex;
    flex-wrap: wrap;
    column-gap: 40px;
    row-gap: 20px;
    margin-top: 30px;
    overflow-y: scroll;
    &::-webkit-scrollbar { // chrome/safari
      display: none;
    }
    scrollbar-width: none; // firefox
    -ms-overflow-style: none; // IE10+
    .history-item {
      height: 40px;
      display: grid;
      place-items: center;
      background-color: #F5F5F5;
      border-radius: 30px;
      padding: 10px 26px;
      box-sizing: border-box;
      font-size: 16px;
      color: #333;
      cursor: pointer;
      transition: all ease-in-out .2s;
      &:hover {
        background-color: #70B19C;
        color: #fff;
      }
    }
  }
  .no-history {
    height: 100px;
    font-size: 14px;
    font-weight: bold;
    color: #999;
    display: grid;
    place-items: center;
  }
  .recommend-title {
    margin-top: 40px;
  }
  .recommend-container {
    width: 680px;
    height: 230px;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    .recommend-item {
      height: 50px;
      display: flex;
      align-items: center;
      column-gap: 40px;
      padding: 10px;
      box-sizing: border-box;
      border-radius: 6px;
      cursor: pointer;
      transition: all ease-in-out .2s;
      &:hover {
        background-color: #70B19C;
        .item-title {
          color: #fff;
        }
        .item-type {
          background-color: #fff;
          color: #70B19C;
        }
      }
      .item-title {
        flex: 1;
        font-size: 16px;
        color: #000;
      }
      .item-type {
        min-width: 50px;
        padding: 5px 12px;
        box-sizing: border-box;
        display: grid;
        place-items: center;
        background-color: #F5F5F5;
        border-radius: 4px;
        font-size: 12px;
        color: #333;
      }
    }
  }
}
/* search result */
.search-result {
  width: 920px;
  height: 600px;
  .search-result-list-box {
    width: 930px;
    height: 425px;
    display: grid;
    place-items: center;
  }
  .search-result-list-container {
    width: 930px;
    height: 385px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-top: 30px;
    overflow-y: scroll;
    // &::-webkit-scrollbar { // chrome/safari
    //   display: none;
    // }
    // scrollbar-width: none; // firefox
    // -ms-overflow-style: none; // IE10+
    &::-webkit-scrollbar { // chrome/safari
      width: 5px;
    }
    &::-webkit-scrollbar-track {
      // background:#e4e4e4;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: #70B19C;
      border-radius: 3px;
    }
  }
}
/* 键盘 */
.form-card {
  width: 680px;
  border-radius: 5px;
  box-sizing: border-box;
  margin-top: 140px;
  display: flex;
  justify-content: center;
  transform: translate(-55px);
  position: relative;
  .search-btn-box {
    width: 80px;
    height: 40px;
    border-radius: 0 2px 2px 0;
    // padding: 3px;
    box-sizing: border-box;
    background-color: #F5F5F5;
    display: grid;
    place-items: center;
    margin-left: 110px;
    button {
      width: 74px;
      height: 34px;
      background-color: #70B19C;
      border-radius: 2px;
      font-size: 16px;
      color: #fff;
      &:hover {
        background-color: #79c2ab;
      }
    }
  }
}
.el-icon-error {
  position: absolute;
  left: 518px;
  bottom: 285px;
  font-size: 22px;
  color: #70B19C;
  cursor: pointer;
}
.drop-list {
  position: absolute;
  left: 205px;
  bottom: 285px;
  width: 378px;
  height: 270px;
  background-color: #fff;
  border: 2px solid #70B19C;
  // box-shadow: 0px 0px 15px 0px rgba(177,8,8,0.15);
  border-radius: 4px;
  padding: 10px 0 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 6px;
  // transform: translateY(235px);
  overflow-y: scroll;
  &::-webkit-scrollbar { // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
  // z-index: 3;
  .drop-list-item {
    flex-shrink: 0;
    width: 370px;
    background-color: #fff;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    box-sizing: border-box;
    cursor: pointer;
    .item-title {
      width: 280px;
      font-size: 17px;
      font-weight: bold;
      color: #333;
      &:hover {
        text-decoration: underline;
      }
    }
    .item-type {
      font-size: 16px;
      color: #333;
    }
  }
}

.drop-list-enter-active, .drop-list-leave-active {
  transition: all ease-in-out .2s;
}
.drop-list-enter, .drop-list-leave-to {
  opacity: 0.5;
  transform: translateY(1px);
  height: 0;
}
.drop-list-enter-to, .drop-list-leave {
  opacity: 1;
  transform: translateY(0);
  height: 270px;
}
.drop-icon-enter-active, .drop-icon-leave-active {
  transition: all ease-in-out .22s;
}
.drop-icon-enter, .drop-icon-leave-to {
  opacity: 0.5;
  // transform: translateY(270px);
}
.drop-icon-enter-to, .drop-icon-leave {
  opacity: 1;
  // transform: translateY(40px);
}
</style>

<style lang="scss">
.keyboard-comp {
  width: 300px;
  input {
    width: 300px;
    height: 40px;
    background-color: #F5F5F5;
    border-radius: 2px 0 0 2px;
    border: none;
    box-sizing: border-box;
  }
  .el-input {
    margin-left: 110px;
  }
}
.search-res-pagination-box {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #70B19C;
    color: #fff;
    &:hover {
      color: #fff;
    }
  }
  .el-pagination .el-pager li:not(.disabled):hover {
    color: #70B19C;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #70B19C;
  }
}

.clear-history-confirm {
  background-color: #000B14;
  border-color: #70B19C;
  .el-message-box__content {
    color: #70B19C;
  }
  .clear-history-confirm-btn {
    background-color: #70B19C !important;
    color: #fff !important;
    border-color: #70B19C !important;
    &:hover {
      background-color: #76bea7 !important;
    }
  }
  .clear-history-confirm-cancel-btn {
    color: #000B14;
    &:active {
      border-color: #70B19C !important;
      color: #70B19C !important;
    }
    &:hover {
      color: #76bea7 !important;
      background-color: #def8f0 !important;
    }
  }
}
</style>
